import type { PostHogConfig } from 'posthog-js';
import { WEB_RELEASE } from '../utils/release';
import { runtimeConfig as runtime } from './runtime';

const getEnvironmentVariable = (unvalidatedEnvironmentVariable: string | undefined): string => {
  if (!unvalidatedEnvironmentVariable) {
    throw new Error(`Couldn't find environment variable: ${unvalidatedEnvironmentVariable}`);
  } else {
    return unvalidatedEnvironmentVariable;
  }
};

// Deployed builds read runtime config (see ./runtime); local builds use their build-time env
export const env = {
  nodeEnv: getEnvironmentVariable(runtime.NODE_ENV ?? process.env.NODE_ENV),
  apiHost: getEnvironmentVariable(runtime.API_HOST ?? process.env.API_HOST),
  apiWsHost: getEnvironmentVariable(runtime.API_HOST ?? process.env.API_HOST).replace(/^https?/, s => s === 'https' ? 'wss' : 'ws'),
  apiPort: getEnvironmentVariable(runtime.API_PORT ?? process.env.API_PORT),
  apiBase: getEnvironmentVariable(runtime.API_BASE ?? process.env.API_BASE),
  apiVersion: getEnvironmentVariable(runtime.API_VERSION ?? process.env.API_VERSION),
  clientUrl: getEnvironmentVariable(runtime.CLIENT_URL ?? process.env.CLIENT_URL),
  posthog: {
    options: {
      api_host: getEnvironmentVariable(runtime.POSTHOG_HOST ?? process.env.POSTHOG_HOST),
      // Uncaught errors and unhandled rejections go to PostHog error tracking
      capture_exceptions: true,
      // Tag every event (including exceptions) with the build that produced it
      loaded: (ph) => ph.register({ release: WEB_RELEASE }),
    } satisfies Partial<PostHogConfig>,
    api_key: runtime.POSTHOG_KEY ?? process.env.POSTHOG_KEY,
  },
};
